import {
  getAcceptLanguageTag,
  resolveI18nLocaleFromTag,
  findLocaleOption,
} from '@/config/localeOptions';

/** 仅用户在站内手动切换语言时写入；自动跟随系统语言时不落盘 */
export const APP_LANG_STORAGE_KEY = 'appLangUser';
/** 旧版启动即写入的 key，无法区分自动/手动，忽略并清理 */
const LEGACY_APP_LANG_STORAGE_KEY = 'appLang';

const FALLBACK_ACCEPT_LANGUAGE = findLocaleOption('en').acceptLanguage;

function clearLegacyAppLang() {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.removeItem(LEGACY_APP_LANG_STORAGE_KEY);
  } catch {
    /* private mode 等忽略 */
  }
}

export function readStoredAcceptLanguage() {
  if (typeof localStorage === 'undefined') return '';
  clearLegacyAppLang();
  return String(localStorage.getItem(APP_LANG_STORAGE_KEY) ?? '').trim();
}

/** 用户主动选语言时持久化；启动自动解析勿调用 */
export function persistAcceptLanguage(acceptTag) {
  const tag = String(acceptTag ?? '').trim();
  if (!tag || typeof localStorage === 'undefined') return;
  clearLegacyAppLang();
  localStorage.setItem(APP_LANG_STORAGE_KEY, tag);
}

function readBrowserAcceptLanguage() {
  if (typeof navigator === 'undefined') return '';
  const languages = navigator.languages?.length ? navigator.languages : [navigator.language];
  return String(languages[0] ?? '').trim();
}

/** 启动时解析：用户手动偏好 → navigator.language → en-US */
export function resolveInitialLanguage() {
  const stored = readStoredAcceptLanguage();
  const acceptTag = stored || readBrowserAcceptLanguage() || FALLBACK_ACCEPT_LANGUAGE;
  const i18nCode = resolveI18nLocaleFromTag(acceptTag);
  const resolvedTag = getAcceptLanguageTag(i18nCode);
  return { i18nCode, acceptTag: resolvedTag };
}

export { getAcceptLanguageTag };
